import BinSvg from "$assets/icons/bin.svg?icon";
import type { ComponentProps } from "react";

// Defaults to delete-red; callers can recolour via the legacy `fill` prop
// (e.g. fill="currentColor" to inherit text colour).
const BinIcon = ({ fill, ...props }: ComponentProps<typeof BinSvg>) => (
  <BinSvg htmlColor={(fill as string | undefined) ?? "#D23201"} {...props} />
);

export default BinIcon;
